// extracted by mini-css-extract-plugin
module.exports = {"adregion":"adregion-1tghVO83"};